module.exports = { "default": require("core-js/library/fn/string/from-code-point"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/string/from-code-point.js
// module id = qUhW
// module chunks = 3